/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  createDialogRoute,
  FormStateBuilder,
} from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import {
  DialogInput,
  DialogService,
  NotificationService,
  responsiveDialogOverlayPaneClass,
  WaitingService,
} from '@gh/core-ui';

import { BuilderUserContext } from '../../../user';

import {
  CommunicationsBusinessService, WebsiteDialogConfig,
} from '../../resources/communications-business.service';



@Component({
  standalone: false,
  selector: 'gh-website-dialog',
  templateUrl: 'website-dialog.component.html',
})

export class WebsiteDialogComponent implements OnInit, DialogInput<WebsiteDialogConfig> {
  input: WebsiteDialogConfig;

  constructor(private formStateBuilder: FormStateBuilder,
              private userContext: BuilderUserContext,
              private businessService: CommunicationsBusinessService,
              private waitingService: WaitingService,
              public dialogRef: MatDialogRef<WebsiteDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private dialogData: any,
              private notificationService: NotificationService,
              private translationService: TranslationService,
              private dialogService: DialogService) {

  }

  ngOnInit(): void {
    const website = this.input.website;
    if (website && !website.communicationId && !website.isMarkedAsRead) {
      this.businessService.readSms(website.communicationId!).pipe(
        this.waitingService.operator(),
      ).subscribe((response) => {
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}

export const websiteDialogRoute = createDialogRoute({
  component: WebsiteDialogComponent,
  config: {
    disableClose: true,
    maxHeight: '100vh',
    panelClass: responsiveDialogOverlayPaneClass(),
  },
});
